import Button from '../../../ui_components/button/button';
import ValidationForm, { FormValidationError } from '../../../ui_components/validation/validationForm';
import { ValidationPopupInput } from '../../../ui_components/validation/validationPopupInput';
import { PopoverScrollContext } from '../../../ui_components/popover/popover';
import {
  Modal,
  ModalActions,
  ModalHeader,
} from '../../../ui_components/modal';
import PageDimmer from '../../../ui_components/dimmer/PageDimmer';
import { ClientPricingAction, PricingType } from '../types';
import {
  DraperyItemDetailsFieldsPartial,
  draperyItemDetailsFieldsInitialState,
  draperyItemDetailsFieldsReducer,
} from '../../../redux/modules/my-shop/drapery-item-details-fields-reducer';
import { ConfirmationCloseModal } from '../../../modals/confirmation_close_modal';
import {
  FormFieldsPartial,
  formFieldsInitialState,
  formFieldsReducer,
} from '../../../redux/modules/my-shop/form-fields-reducer';
import { ItemModalContent, ItemTabs, TabContainer } from '../styles';
import React, {
  FC,
  FormEvent,
  KeyboardEvent,
  useEffect,
  useReducer,
  useRef,
  useState,
} from 'react';
import { Prompt } from 'react-router-dom';
import { Tab, TabList } from 'react-tabs';
import { addDraperyRecord, getDraperyRecord, updateDraperyRecord } from '../../../api/item';
import { draperyPricingTypes, draperyWidthRoundUpTypes } from '../constants';
import styled, { theme } from '../../../theme';
import { useDispatch } from 'react-redux';

import { Category } from '../../../interfaces/category';
import { ConstructionSettings } from './construction-settings/main';
import Details from './details';
import { HelpPopup } from '../../content/help_popup';
import Pricing from './pricing';
import { Supplier } from '../../../interfaces/supplier';
import { detect } from 'detect-browser';
import { getSelectedName } from '../helpers';
import PricingAlert from '../../../assets/icons/pricingalert.svg';
import { confirmation } from '../../../confirmation';
import { trackView } from '../../analytics/track_view';
import { MixpanelEvents } from '../../analytics/mix_panel_events';

const CancelButton = styled(Button)`
`;

export const FormLabel = styled.label`
  color: ${theme.colors.grayRGBA} !important;
  margin-bottom: 2px !important;

  .red-asterisk {
    color: ${theme.colors.red} !important;
  }
`;

export const FormInput = styled(ValidationPopupInput)`
  padding: 0.35em 0.5em !important;
`;

export const RadioLabel = styled.label`
  display: inline-flex !important;
  align-items: center !important;
  margin-right: 30px !important;

  > label:hover,
  &:hover {
    cursor: pointer !important;
  }
`;

export const RadioInput = styled(ValidationPopupInput)`
  border-radius: 50% !important;
  width: 15px !important;
  height: 15px !important;
  font-size: 0 !important;
  margin-right: 5px !important;
  border: 1px solid ${theme.colors.grayRGBA} !important;
  border: ${(props) => (props.checked ? `5px solid ${theme.colors.blue}` : '')} !important;

  input {
    visibility: hidden !important;
  }
`;

export const TextAreaContainer = styled.div`
  width: 90% !important;
  display: flex !important;
  flex-direction: column !important;
  margin-top: 10px !important;

  span {
    margin-top: 5px !important;
    margin-right: 10px !important;
  }

  .text-area {
    width: 100% !important;
    border: solid ${theme.colors.primary} 1px !important;
    height: 120px !important;
  }
`;

export const RightCell = styled.div`
  width: 50% !important;
  margin-bottom: 20px !important;
  padding-right: 1.25rem !important;
  padding-right: 0 !important;
  padding-left: 1.25rem !important;
`;

export const RightCellWithBorder = styled(RightCell)`
  border-left: 1px solid ${theme.colors.blue} !important;
`;

export const TooltipPopup = styled(HelpPopup)`
  max-width: 300px !important;
  max-height: 50% !important;
  display: flex !important;

  > svg {
    color: ${theme.colors.red1} !important;
  }
`;
const ModalItem = styled(Modal)`
  width: 90% !important;
  min-height: 300px !important;
  bottom: 0px !important;
`;
const ValidationFormDrapery = styled(ValidationForm)`
  min-height: inherit !important;
`;
interface RomanShadeModalProps {
  isModalOpen: boolean;
  categories: Category[];
  suppliers: Supplier[];
  itemId: number | null;
  supplierId?: number | null;
  supplierName: string;
  onModalClose(): void;
  fetchAll(): void;
  openModalClick?(): void;
  reloadGrid(): void;
  validateAll?(mode: string): boolean;
  updateStateByName?(
    name: string,
    value: string | number | boolean | number[] | undefined | object,
    isSaving?: boolean
  ): void;
  isPleatModalOpen?: boolean;
  showRomanShadeModal?: boolean;
  history?: any;
  tabIndex?: number;
  activeItemClassId: number | null;
  reloadOnSave?(): void;
  setSupplierId?: (id: number | null) => any;
  setSupplierName?: (name: string) => any;
  highLightInput?: string[];
  isEstimateSettingsReadOnly?: boolean;
}

interface ScrollInfo {
  scrollX: number;
  scrollY: number;
}

const RomanShadeModal: FC<RomanShadeModalProps> = ({
  isModalOpen,
  categories,
  fetchAll,
  suppliers,
  itemId,
  openModalClick,
  onModalClose,
  reloadGrid,
  updateStateByName,
  isPleatModalOpen,
  showRomanShadeModal,
  history,
  tabIndex,
  activeItemClassId,
  supplierId,
  supplierName,
  reloadOnSave,
  highLightInput,
  setSupplierId,
  setSupplierName,
  isEstimateSettingsReadOnly,
}) => {
  const constructionDispatch = useDispatch();
  const constructionRef = useRef<any>(null);

  const [isChanged, setIsChanged] = useState<boolean>(false);

  const accountId = parseFloat(localStorage.getItem('accountId') || '0');
  const browser = detect();
  const [isCloseModalActive, setIsCloseModalActive] = useState<boolean>(false);
  const [activeTabIndex, setActiveTabIndex] = useState<number>(tabIndex || 0);
  const [areaScrollInfo, setAreaScrollInfo] = useState<ScrollInfo>({
    scrollX: 0,
    scrollY: 0,
  });

  const [copyFormFields, copyDispatch] = useReducer(formFieldsReducer, formFieldsInitialState);
  const [formFields, dispatch] = useReducer(formFieldsReducer, formFieldsInitialState);

  const [copyDraperyItemDetailsFields, copyDispatchItemDetails] = useReducer(
    draperyItemDetailsFieldsReducer,
    {
      ...draperyItemDetailsFieldsInitialState,
      salesDescriptionSettings: [],
      orderingDescriptionSettings: [],
    }
  );
  const [draperyItemDetailsFields, dispatchItemDetails] = useReducer(
    draperyItemDetailsFieldsReducer,
    {
      ...draperyItemDetailsFieldsInitialState,
      salesDescriptionSettings: [],
      orderingDescriptionSettings: [],
    }
  );
  const [errorFields, setErrorFields] = useState<{ name: string }[]>([]);
  const [errorElementId, setErrorElementId] = useState<string | null>(null);
  const [triggerFocus, setTriggerFocus] = useState<boolean>(false);
  const [firstError, setFirstError] = useState<{ name: string; show: boolean } | null>(null);

  useEffect(() => {
    if (errorFields && errorFields.length > 0) {
      if (errorFields[0].name === 'pricingTypeId') {
        const el1 = document.getElementById(`${errorFields[0].name}-selectList`);
        if (el1) {
          el1.focus();
        }
      } else {
        const el = document.getElementById(errorFields[0].name);
        if (el) {
          el.focus();
        }
      }
    }
  }, [triggerFocus]);

  const hideErrorMessagePopUp = (e: any) => {
    let id = e.currentTarget.id;
    if (id && id.includes('selectList')) {
      id = id.split('-')[0];
    }
    if (firstError && firstError.name === id) {
      // If user wants to see more than 1 time error pop up message
      // setFirstError((prev: any) => {
      //     return {
      //         ...prev,
      //         show: false
      //     }
      // })
      setFirstError(null);
    }
  };

  const showErrorMessagePopUp = (e: any) => {
    let id = e.currentTarget.id;
    if (id && id.includes('selectList')) {
      id = id.split('-')[0];
    }
    if (firstError && firstError.name === id) {
      setFirstError((prev: any) => {
        return {
          ...prev,
          show: true,
        };
      });
    }
  };

  const handleInvalidElem = (elem: HTMLElement): void => {
    const elemId = elem.id;

    if (['name', 'itemCategory', 'itemTypeProduct', 'itemTypeService'].includes(elemId)) {
      setActiveTabIndex(0);
    } else {
      setActiveTabIndex(1);
    }

    setErrorElementId(elemId);
  };
  const removeErrorsById = (id: string) => {
    const filteredErrors =
      errorFields && errorFields.length > 0 ? errorFields.filter((i) => i.name !== id) : [];
    if (firstError && firstError.name === id) {
      setFirstError(null);
    }
    setErrorFields(filteredErrors);
  };

  const saveConstructionSettings = async () => {
    if (!constructionRef.current) return false;

    const result = await constructionRef.current.saveCurrentSetting();
    return result;
  };

  const handleSubmitForm = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    if (isEstimateSettingsReadOnly) {
      return;
    }

    let errors: { name: string }[] = [];
    let pricingKeys = [
      'pricingTypeId',
      'clientPricingValue',
      'pleatTypesWithPricing',
      'liningAndInterliningWithPricing',
      'valanceAndReturns',
      'extraLargePanelsLengthInches',
      'extraLargePanelsLengthPricing',
      'extraLargePanelsWidthInches',
      'extraLargePanelsWidthPricing',
      'specialityFabricsMarkUpPercentage',
      'embellishmentsWithPricing',
    ];
    if (
      !draperyItemDetailsFields['pricingTypeId'] ||
      !draperyItemDetailsFields['isClientPricingActionOn']
    ) {
      pricingKeys = [
        'pricingTypeId',
        'pleatTypesWithPricing',
        'liningAndInterliningWithPricing',
        'valanceAndReturns',
        'extraLargePanelsLengthInches',
        'extraLargePanelsLengthPricing',
        'extraLargePanelsWidthInches',
        'extraLargePanelsWidthPricing',
        'specialityFabricsMarkUpPercentage',
        'embellishmentsWithPricing',
      ];
    }

    for (const key of pricingKeys) {
      const val = draperyItemDetailsFields[key];

      if (!val || (typeof val === 'string' && val.trim() === '')) {
        errors.push({
          name: key,
        });
      }

      if (key === 'embellishmentsWithPricing') {
        if (Array.isArray(val)) {
          for (let i = 0; i < val.length; i++) {
            if (
              val[i] &&
              val[i].group &&
              val[i].group.name !== 'Trim from fabric' &&
              val[i].group.items &&
              val[i].group.items.length > 0
            ) {
              for (let j = 0; j < val[i].group.items.length; j++) {
                if (val[i].group.items[j] && val[i].group.items[j].price === '') {
                  errors.push({
                    name: val[i].group.items[j].id,
                  });
                }
              }
            }
          }
        }
      }
      if (Array.isArray(val)) {
        for (let i = 0; i < val.length; i++) {
          if (val[i].price === '') {
            errors.push({
              name: val[i].id,
            });
          }
        }
      }
    }

    setErrorFields(errors);
    if (errors && errors.length > 0) {
      setActiveTabIndex(1);
      setTriggerFocus((prev) => !prev);
      setFirstError({
        ...errors[0],
        show: true,
      });
      return;
    }

    setErrorElementId(null);
    if (!isPleatModalOpen) {
      const { name, itemNumber, avatarId, itemTypeId, categoryId, notes, isActive } = formFields;

      let payload: FormFieldsPartial = {
        name,
        itemNumber,
        avatarId,
        itemTypeId,
        supplierId,
        categoryId,
        notes,
        isActive,
      };

      const {
        pricingTypeId,
        isClientPricingActionOn,
        clientPricingAction,
        clientPricingValue,
        isPartialWidthRoundingOn,
        partialWidthRoundUpTypeId,
        pleatTypesWithPricing,
        liningAndInterliningWithPricing,
        cafeCurtainsWidthInches,
        cafeCurtainsWidthPricing,
        extraLargePanelsLengthInches,
        extraLargePanelsLengthPricing,
        valanceAndReturns,
        extraLargePanelsWidthInches,
        extraLargePanelsWidthPricing,
        draperyPinningWidthPricing,
        specialityFabricsMarkUpPercentage,
        embellishmentsWithPricing,
        addOnsWithPricing,
        salesDescriptionSettings,
        orderingDescriptionSettings,
        isBundlingSelected,
        bundleSelections,
      } = draperyItemDetailsFields;

      let detailsPayload: DraperyItemDetailsFieldsPartial = {
        pricingTypeId,
        isClientPricingActionOn,
        clientPricingAction,
        clientPricingValue,
        isPartialWidthRoundingOn,
        partialWidthRoundUpTypeId,
        pleatTypesWithPricing,
        liningAndInterliningWithPricing,
        cafeCurtainsWidthInches,
        cafeCurtainsWidthPricing,
        extraLargePanelsLengthInches,
        extraLargePanelsLengthPricing,
        extraLargePanelsWidthInches,
        extraLargePanelsWidthPricing,
        draperyPinningWidthPricing,
        valanceAndReturns,
        specialityFabricsMarkUpPercentage,
        embellishmentsWithPricing,
        addOnsWithPricing,
        salesDescriptionSettings,
        orderingDescriptionSettings,
        isBundlingSelected,
        bundleSelections,
      };
      let comboPayload = {
        ...payload,
        ...detailsPayload,
      };
      if (updateStateByName) {
        for (const key in detailsPayload) {
          if (
            [
              'pricingTypeId',
              'clientPricingAction',
              'clientPricingValue',
              'partialWidthRoundUpTypeId',
              'pleatTypesWithPricing',
              'liningAndInterliningWithPricing',
              'valanceAndReturns',
              'cafeCurtainsWidthInches',
              'cafeCurtainsWidthPricing',
              'extraLargePanelsLengthInches',
              'extraLargePanelsLengthPricing',
              'extraLargePanelsWidthInches',
              'extraLargePanelsWidthPricing',
              'draperyPinningWidthPricing',
              'specialityFabricsMarkUpPercentage',
              'embellishmentsWithPricing',
              'addOnsWithPricing',
              'salesDescriptionSettings',
              'orderingDescriptionSettings',
              'isBundlingSelected',
              'bundleSelections',
            ].includes(key)
          ) {
            updateStateByName(`romanShadeItemDetails.0.${key}`, detailsPayload[key]);
          }
        }
      }

      if (updateStateByName) {
        for (const key in detailsPayload) {
          if (
            [
              'pricingTypeId',
              'clientPricingAction',
              'clientPricingValue',
              'partialWidthRoundUpTypeId',
              'pleatTypesWithPricing',
              'liningAndInterliningWithPricing',
              'valanceAndReturns',
              'cafeCurtainsWidthInches',
              'cafeCurtainsWidthPricing',
              'extraLargePanelsLengthInches',
              'extraLargePanelsLengthPricing',
              'extraLargePanelsWidthInches',
              'extraLargePanelsWidthPricing',
              'draperyPinningWidthPricing',
              'specialityFabricsMarkUpPercentage',
              'embellishmentsWithPricing',
              'addOnsWithPricing',
              'salesDescriptionSettings',
              'orderingDescriptionSettings',
              'isBundlingSelected',
              'bundleSelections',
            ].includes(key)
          ) {
            updateStateByName(`romanShadeItemDetails.0.${key}`, detailsPayload[key]);
          }
        }
      }

      let result: any;

      if (itemId) {
        comboPayload = {
          ...comboPayload,
          id: itemId,
        };
        result = await updateDraperyRecord(comboPayload);

        trackView(MixpanelEvents.SAVE_FABRICATION, {order_type: 'roman_shade'});
      } else {
        result = await addDraperyRecord(comboPayload);
      }

      const constructionSaved = await saveConstructionSettings();

      await fetchAll();

      const errors = result.data.errors;
      const status = result.status;

      if (errors) {
        setAreaScrollInfo({
          scrollX: 0,
          scrollY: 0,
        });
        throw FormValidationError.fromErrorDictionary(errors);
      } else if (!constructionSaved) {
        setActiveTabIndex(2);
        setErrorElementId('errorMessage');
      } else if ([201, 200].includes(status)) {
        if (reloadOnSave) {
          reloadOnSave();
        }
        onSaveClose();
        if (showRomanShadeModal && history) {
          localStorage.removeItem('romanShadeItem');
        }
        reloadGrid();
      }
    }
  };

  const deepEqual = (obj1: any, obj2: any): boolean => {
    if (obj1 === obj2) return true;

    if (obj1 == null || obj2 == null) return false;

    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) return false;
    }

    return true;
  };

  const handleKeyPressForm = (e: KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
    }
  };

  const selectTab = (index: number) => {
    if (isEstimateSettingsReadOnly && index !== 0) {
      return false;
    }
    setActiveTabIndex(index);
    setAreaScrollInfo({
      scrollX: 0,
      scrollY: 0,
    });
    return true;
  };

  // const onClose = () => {
  //     dispatch({ type: "resetFormFields" });
  //     setActiveTabIndex(0);
  //     onModalClose();
  // };
  const onClose = () => {
    if (isEstimateSettingsReadOnly) {
      setIsCloseModalActive(false);
      dispatch({ type: 'resetFormFields' });
      setActiveTabIndex(0);
      onModalClose();
      return;
    }

    if (
      deepEqual(formFields, copyFormFields) &&
      deepEqual(draperyItemDetailsFields, copyDraperyItemDetailsFields) &&
      !isChanged
    ) {
      setIsCloseModalActive(false);
      dispatch({ type: 'resetFormFields' });
      setActiveTabIndex(0);
      onModalClose();

      trackView(MixpanelEvents.CANCEL_EDIT_FABRICATION, {order_type: 'roman_shade'});
    } else {
      showEditWorkOrderConfirm();
    }
  };

  const onSaveClose = () => {
    dispatch({ type: 'resetFormFields' });
    setActiveTabIndex(0);
    onModalClose();
    history.push('/calculator?type=roman-shade-order');
  };

  const renderDetails = (): JSX.Element => {
    return (
      <TabContainer>
        <Details
          openModalClick={openModalClick}
          categories={categories}
          suppliers={suppliers}
          browser={browser}
          supplierName={supplierName}
          supplierId={supplierId}
          setSupplierId={setSupplierId}
          setSupplierName={setSupplierName}
          formFields={formFields}
          dispatch={dispatch}
          copyDispatch={copyDispatch}
          draperyItemDetailsFields={draperyItemDetailsFields}
          dispatchItemDetails={dispatchItemDetails}
          isEstimateSettingsReadOnly={isEstimateSettingsReadOnly}
        />
      </TabContainer>
    );
  };

  const renderPricing = (): JSX.Element => {
    return (
      <TabContainer>
        <Pricing
          browser={browser}
          draperyItemDetailsFields={draperyItemDetailsFields}
          dispatch={dispatchItemDetails}
          activeItemClassId={activeItemClassId}
          itemId={itemId}
          formFields={formFields}
          highLightInput={highLightInput}
          removeErrorsById={removeErrorsById}
          errorFields={errorFields}
          firstError={firstError}
          hideErrorMessagePopUp={hideErrorMessagePopUp}
          showErrorMessagePopUp={showErrorMessagePopUp}
        />
      </TabContainer>
    );
  };

  const renderConstructionSettings = (): JSX.Element => {
    return (
      <TabContainer>
        <ConstructionSettings
          dispatch={constructionDispatch}
          setIsChanged={setIsChanged}
          accountId={accountId}
          ref={constructionRef}
        />
      </TabContainer>
    );
  };

  // const getModalTitle = (): JSX.Element | "" => {
  //     const { categoryName, name } = formFields;

  //     if (!categoryName && !name) {
  //         return (
  //             <span className="text-twPrimary font-medium">Add New Item</span>
  //         );
  //     }

  //     return (
  //         <div>
  //             {categoryName && (
  //                 <>
  //                     <span className="text-twBlue">{categoryName}</span>
  //                     <span className="p-1">|</span>
  //                 </>
  //             )}
  //             <span className="text-twBlue">{`${name || ""}`}</span>
  //         </div>
  //     );
  // };

  useEffect(() => {
    if (itemId) {
      getDraperyRecord({ recordId: itemId })
        .then((res) => {
          const { pleatTypesWithPricing } = res;
          const itemUpdates: FormFieldsPartial = {
            ...res,
            pleatTypesWithPricing: pleatTypesWithPricing || [],
          };
          const draperyItemDetailsUpdates: DraperyItemDetailsFieldsPartial = {
            ...res,
          };

          if (pleatTypesWithPricing) {
            const ripplefoldPleat = pleatTypesWithPricing.find(
              (pleat) => pleat.id === 'ripplefold' && pleat.price === ''
            );
            const currentPath = window.location.pathname;
            if (!isEstimateSettingsReadOnly && ripplefoldPleat && currentPath !== '/myshop') {
              setActiveTabIndex(1);
            }
          }

          const supplierName = getSelectedName({
            list: suppliers as [],
            findByKey: 'id',
            findValue: itemUpdates.supplierId,
            nameField: 'displayName',
          });

          const pricingTypeName = getSelectedName({
            list: draperyPricingTypes as [],
            findByKey: 'key',
            findValue: draperyItemDetailsUpdates.pricingTypeId,
            nameField: 'label',
          });

          const partialWidthRoundUpTypeName = getSelectedName({
            list: draperyWidthRoundUpTypes as [],
            findByKey: 'key',
            findValue: draperyItemDetailsUpdates.partialWidthRoundUpTypeId,
            nameField: 'label',
          });

          copyDispatch({
            type: 'updateFormFields',
            formFieldUpdates: {
              ...itemUpdates,
              supplierName,
            },
          });
          dispatch({
            type: 'updateFormFields',
            formFieldUpdates: {
              ...itemUpdates,
              supplierName,
            },
          });

          copyDispatchItemDetails({
            type: 'updateFormFields',
            formFieldUpdates: {
              ...draperyItemDetailsUpdates,
              pricingTypeName,
              partialWidthRoundUpTypeName,
            },
          });
          dispatchItemDetails({
            type: 'updateFormFields',
            formFieldUpdates: {
              ...draperyItemDetailsUpdates,
              pricingTypeName,
              partialWidthRoundUpTypeName,
            },
          });
        })
        .catch((err) => {
          console.log(`error fetching drapery item: ${err}`);
        });
    } else {
      const pricingTypeName = getSelectedName({
        list: draperyPricingTypes as [],
        findByKey: 'key',
        findValue: draperyItemDetailsFields.pricingTypeId,
        nameField: 'label',
      });
      const clientPricingAction =
        pricingTypeName === PricingType.Retail
          ? ClientPricingAction.Discount
          : ClientPricingAction.MarkUp;

      copyDispatchItemDetails({
        type: 'updateFormFields',
        formFieldUpdates: {
          pricingTypeName,
          clientPricingAction,
        },
      });
      dispatchItemDetails({
        type: 'updateFormFields',
        formFieldUpdates: {
          pricingTypeName,
          clientPricingAction,
        },
      });
    }
  }, [itemId, suppliers]);

  useEffect(() => {
    if (errorElementId) {
      const errorElement = document.getElementById(errorElementId);
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        errorElement.focus();
      }
    }
  }, [errorElementId]);
  const handleNextChange = () => {
    if (isEstimateSettingsReadOnly) {
      return;
    }
    if (activeTabIndex < 2) {
      setActiveTabIndex(activeTabIndex! + 1);
    }
  };

  const showEditWorkOrderConfirm = (): Promise<boolean> => {
    return confirmation(<div>Would you like to cancel your edits?</div>, {
      uiHeader: 'Confirmation',
      uiAcceptLabel: 'No, continue editing',
      uiDeclineLabel: 'Yes, cancel edits',
      workOrderEditMode: true,
      cancelEditing: () => {
        onModalClose();

        trackView(MixpanelEvents.CANCEL_EDIT_FABRICATION, {order_type: 'roman_shade'});
      },
    });
  };

  // MIXPANEL TRACKING ***
  useEffect(() => {
    const index_view_relation: any = {
      0: MixpanelEvents.MY_SHOP_FABRICATION_DETAILS,
      1: MixpanelEvents.MY_SHOP_FABRICATION_PRICING,
      2: MixpanelEvents.MY_SHOP_FABRICATION_SETTINGS,
    };
    trackView(index_view_relation[activeTabIndex], {});
  }, [activeTabIndex]);

  useEffect(() => {
    if (isModalOpen && itemId) {
      trackView(MixpanelEvents.MY_SHOP_FABRICATION, {});
    }
  }, [isModalOpen]);
  /** END OF MIXPANEL TRACKING *** */

  return (
    <>
      <Prompt
        message={(location: any): string | boolean => {
          if (isModalOpen) {
            showEditWorkOrderConfirm();
            return false;
          } else {
            window.location.replace('/myshop');
            return true;
          }
        }}
      />
      <PageDimmer uiActive={isModalOpen} />
      <ModalItem
        uiActive={isModalOpen}
        uiOnRequestClose={() => {
          return;
        }}
        uiDefaultSizes={false}
      >
        <ValidationFormDrapery
          uiOnSubmit={handleSubmitForm}
          uiReportValidityMode="firstInvalid"
          uiOnInvalidElem={handleInvalidElem}
          onKeyPress={handleKeyPressForm}
          uiPadding={false}
          className="h-full"
        >
          <ModalHeader className="border-0">
            <div className="flex justify-between w-full pb-2 border-b-8 border-twSecondary">
              <div>
                <>
                  <span className="text-twBlue">Fabrication</span>
                  <span className="p-1">|</span>
                </>
                <span className="text-twBlue">Roman Shade</span>
              </div>
            </div>
          </ModalHeader>

          <ItemModalContent className="mb-8" style={{ marginTop: '-20px' }}>
            <PopoverScrollContext.Provider value={areaScrollInfo}>
              <ItemTabs
                selectedIndex={activeTabIndex}
                onSelect={selectTab}
                forceRenderTabPanel
                className="flex flex-col flex-1 h-full"
              >
                <TabList>
                  <Tab>Estimate Settings</Tab>
                  <Tab disabled={!!isEstimateSettingsReadOnly}>Pricing</Tab>
                  <Tab disabled={!!isEstimateSettingsReadOnly}>Construction Settings</Tab>
                  {activeTabIndex === 1 && (
                    <Tab
                      disabled
                      style={{
                        border: 'none',
                        background: '#FDF2DC',
                        float: 'right',
                        marginTop: '-4px',
                        borderRadius: '8px',
                        gap: '12px',
                        color: '#9C6B08',
                        fontSize: '14px',
                        fontWeight: '500',
                        lineHeight: '25px',
                        display: 'flex',
                        alignItems: 'center',
                        paddingInline: '10px',
                        height: '36px',
                        width: '263px',
                      }}
                    >
                      <PricingAlert
                        style={{
                          padding: '3.24px',
                          width: '22px',
                          height: '22px',
                          top: '11px',
                          left: '15px',
                          gap: '0px',
                          borderRadius: '6px',
                          opacity: '0px',
                          backgroundColor: '#FFC043',
                        }}
                      />
                      All pricing fields are REQUIRED
                    </Tab>
                  )}
                </TabList>
                {renderDetails()}
                {renderPricing()}
                {renderConstructionSettings()}
              </ItemTabs>
            </PopoverScrollContext.Provider>
          </ItemModalContent>

          <ModalActions>
            <CancelButton
              type="button"
              uiColor="secondary"
              onClick={onClose}
              className="cancel_btn rounded-lg mr-auto block shadow-none"
            >
              {isEstimateSettingsReadOnly ? 'Close' : 'Cancel'}
            </CancelButton>
            {!isEstimateSettingsReadOnly &&
              (activeTabIndex >= 2 ? (
                <Button
                  className="rounded-lg border border-twBlue2 block shadow-none"
                  uiColor="primary"
                  id="saveForm"
                >
                  Save
                </Button>
              ) : (
                <CancelButton
                  type="button"
                  className="cancel_btn rounded-lg block shadow-none"
                  uiColor="secondary"
                  onClick={handleNextChange}
                >
                  Next
                </CancelButton>
              ))}
          </ModalActions>
        </ValidationFormDrapery>
      </ModalItem>
      <ConfirmationCloseModal
        uiAcceptLabel="Yes"
        uiDeclineLabel="No"
        uiHeader="Confirmation"
        uiActive={isCloseModalActive}
        uiOnConfirm={() => {
          dispatch({ type: 'resetFormFields' });
          setActiveTabIndex(0);
          onModalClose();
        }}
        uiOnClose={() => setIsCloseModalActive(false)}
        uiOnRequestClose={() => setIsCloseModalActive(false)}
        uiCloseOnOutsideClick={true}
        uiCloseOnEsc={true}
      >
        Are you sure you want to exit without saving the changes?
      </ConfirmationCloseModal>
    </>
  );
};

export default RomanShadeModal;
